import User from "../../entities/User";
import UserDBInterface from "../interfaces/UserDBInterface";
import { findWithRedux } from "./utils/find_firebase";

export default class UserFirebase implements UserDBInterface{
  async find(id:string):Promise<User | undefined>{
    return findWithRedux(id, "users", User);
  }
}